import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ReferenceAnchorIndexGenerator } from '../reference-anchor';
import { Emitter } from '@patsnap/tahiti-core';

@injectable()
export class ReferenceAnchorIndexGeneratorImpl implements ReferenceAnchorIndexGenerator {
    private _indexMap = new Map<string, number>();
    private _currentIndex = 1;

    private _onStateChangeEmitter = new Emitter<[string, number]>();

    get onStateChange() {
        return this._onStateChangeEmitter.event;
    }

    generate(input: string): string {
        let index = this._indexMap.get(input);

        if (!index) {
            index = this._currentIndex++;
            this._indexMap.set(input, index);
            this._onStateChangeEmitter.fire([input, index]);
        }


        return `${index}`;
    }

    reset() {
        this._currentIndex = 1;
        this._indexMap.clear();
    }

    [Symbol.iterator](): IterableIterator<[string, number]> {
        return this._indexMap.entries();
    }
}
